import { createApp } from 'vue';
import VueGtagPlugin from 'vue-gtag';
import App from './App.vue';
import router from './router';

createApp(App)
  .use(router)
  .use(
    VueGtagPlugin,
    {
      config: {
        id: 'G-8E4G84RG35',
      },
    },
    router,
  )
  .mount('#app');
